module.exports = __webpack_public_path__ + "static/hearts_animation-046de9e0f749f4916d1e1ba1a0fadd6c.svg";